import React, { useRef, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useRootStore } from 'store';
import { GQL_GET_MATERIAL_REPORT } from '../graphql';

import { usePaginatedQueryV8 } from './local-paginated-query';
import GridPage, { MaterialStats } from '../grid/grid';
import { buildWhereFromFilterValues, Filters } from '../filter/filters';

export const MaterialReportContent: React.FC = () => {
  const { t } = useTranslation();
  const gridRef = useRef();
  const { appStore, tableStore } = useRootStore();
  const location = useLocation<any>();
  const initOrderBy = 'totalWeight DESC';

  // Default filters: require user to pick material and date range
  const defaultFilters = {
    materialId: '',
    startDate: null,
    endDate: null,
  };
  const [filters, setFilters] = useState(defaultFilters);

  // Only run the query if all required filters are set
  const filtersReady = Boolean(filters.materialId && filters.startDate && filters.endDate);

  const query: any = usePaginatedQueryV8(
    GQL_GET_MATERIAL_REPORT,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    filtersReady,
    filters,
    false,
    'material_report_grid',
    true,
  );

  const {
    loading,
    rawData,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged: hookFiltersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
    refetch,
  } = query;

  // Custom filtersChanged handler to update local state and call hook
  const filtersChanged = (newFilters) => {
    setFilters(newFilters);
    hookFiltersChanged(newFilters);
  };
  const hasRows = Array.isArray(data) && data.length > 0 && data[0].collectionsCount > 0;

  const stats: MaterialStats | null = Array.isArray(data) && data.length > 0 ? data[0] : null;

  console.log('HAS ROWS', hasRows, 'DATA:', data, 'STATS:', stats, filtersReady);
  // Only show grid if filters are ready and data exists
  return (
    <Card.Body>
      <Filters onChange={filtersChanged} initialValues={filters} disable={false} />
      {filtersReady && hasRows && data && (
        <div className="mt-4">
          <GridPage
            ref={gridRef}
            loading={loading}
            data={stats}
            dataCount={dataCount}
            initPageIndex={initPageIndex}
            onPageChange={gridPageChanged}
            initOrderBy={queryParams?.order ?? initOrderBy}
            onOrderChange={(orderNew) => setQueryParams({ ...queryParams, order: orderNew })}
            appStore={appStore}
            tableStore={tableStore}
          />
        </div>
      )}
      {!filtersReady && (
        <div className="text-center mt-4" style={{ color: 'gray', padding: '20px' }}>
          <h3>{t('Επιλέξτε Υλικό και Hμερομηνίες')}</h3>
        </div>
      )}
      {filtersReady && !hasRows && (
        <div className="text-center mt-4" style={{ color: 'gray', padding: '20px' }}>
          <h3>{t('Δεν υπάρχουν δεδομένα για εμφάνιση')}</h3>
        </div>
      )}
    </Card.Body>
  );
};

export default MaterialReportContent;
